<template>
  <main class="main configurations">
    <div class="white-panel">
      <header class="panel-header space-between">
        <div>
          <router-link
            v-if="serviceID"
            :to="{name: 'ServiceSettingsPage', params: { serviceID: serviceID }}"
            type="button"
            class="step-back"
            aria-label="Voltar atrás"
            title="Voltar atrás"
          />
          <router-link
            v-else
            :to="{name: 'AdminPage'}"
            type="button"
            class="step-back"
            aria-label="Voltar atrás"
            title="Voltar atrás"
          />
          <h2 class="panel-title">
            {{ $t('device.management') }}
          </h2>
        </div>
      </header>

      <div class="config-panel panel-scroll">
        <div
          v-if="displayDevices.length > 0"
          class="label-primary"
        >
          {{ $t('displays') }}
        </div>
        <div
          v-for="device in displayDevices"
          :key="device.id"
          class="row space-between"
        >
          <div
            class="device tv-device"
          >
            <div
              v-if="device.serviceID"
              class="device-name"
            >
              {{ device.serviceID }}
            </div>
            <div v-else>
              {{ $t('unbinded') }}
            </div>
            <div><span>{{ device.ip }}</span></div>
          </div>

          <!-- Device configurations -->
          <div class="device-configs">
            <dropdown size="sm">
              <button
                slot="dropdown-trigger"
                type="button"
                class="btn-more-actions btn-tooltip"
                aria-haspopup="true"
                aria-expanded="false"
                :data-tooltip="$t('more.actions')"
                :aria-label="$t('more.actions')"
                :title="$t('more.actions')"
              />

              <div slot="dropdown-panel">
                <ul class="dropdown-menu">
                  <li
                    class="dropdown-menu__item"
                  >
                    <button
                      class="dropdown-menu__link"
                      @click="editDevice(device)"
                    >
                      <span class="link-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                        >
                          <g
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path d="M0 0h24v24H0z" />
                            <g fill="#8F95A1">
                              <path d="M18.8287402 6.17161133c-1.5622558-1.5618457-4.09494137-1.5618457-5.65675778 0L10.9400293 8.40268555c.17668945-.01921875.35522461-.02748047.53466797-.02748047.56484375 0 1.11410156.08973633 1.63409179.26273437l1.2647461-1.26430664c.43438476-.43485351 1.01206054-.67379883 1.62635744-.67379883.6143554 0 1.1920312.23894532 1.626416.67379883.4344141.43394531.6732715 1.01071289.6732715 1.62591797 0 .61429688-.2388574 1.19197266-.6732715 1.62591797l-2.4745606 2.47458984c-.43435542.43488282-1.0120605.67376953-1.62635738.67376953-.61523437 0-1.19197265-.23888671-1.62679687-.67376953-.21149414-.21058593-.37625977-.45594726-.48978516-.72328125-.28198242.01555664-.545625.13274414-.74704101.33413086l-.65915039.6600293c.18035156.33413086.41197265.64907227.69395508.93202148 1.5618164 1.56190432 4.0949414 1.56190432 5.65719723 0l2.475-2.47549804c1.5613477-1.56175782 1.5613477-4.09400391-.0000293-5.65584961z" />
                              <path d="M13.5519043 16.6238281c-.56578125 0-1.12054688-.0915527-1.65240235-.2719043l-1.27344726 1.2735059c-.43394532.4348828-1.0115918.6737988-1.62588867.6737988-.61429688 0-1.19103516-.238916-1.62591797-.6737988-.43485352-.4339746-.67379883-1.0115918-.67379883-1.625918s.23894531-1.19203123.67379883-1.62682615L9.84880859 11.898125c.43485352-.43394531 1.0116211-.67289062 1.62591797-.67289062.61520508 0 1.19197266.23894531 1.62632813.67289062.21152343.21146484.37666992.45682617.49072265.72413086.28289063-.01464844.54700196-.13274414.74841797-.33413086l.65824219-.65915039c-.18035156-.33509766-.41244141-.65000977-.69486328-.93290039-1.56181641-1.5618457-4.09494141-1.5618457-5.65675781 0l-2.47456055 2.47549805c-1.56272461 1.56190429-1.56272461 4.09406253 0 5.65681643 1.56181641 1.5619043 4.0940625 1.5619043 5.65584961 0l2.22826172-2.228291c-.16614258.015498-.33413086.0238183-.50352539.0238183l-.0009375-.0000879z" />
                            </g>
                          </g>
                        </svg>
                      </span>
                      <span class="link-text">Atribuir</span>
                    </button>
                  </li>
                  <li class="dropdown-menu__item">
                    <button
                      class="dropdown-menu__link"
                      @click="deleteDevice(device)"
                    >
                      <span class="link-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="17"
                        >
                          <g
                            fill="#8F95A1"
                            fill-rule="evenodd"
                          >
                            <path d="M1.16666667 4.57142857H12.8333333v9.65779223c0 1.2935657-1.0353388 2.3422078-2.3328841 2.3422078H3.49955081c-1.28841633 0-2.33288414-1.0439292-2.33288414-2.3422078V4.57142857z" />
                            <path
                              fill-rule="nonzero"
                              d="M10.0087719 1.73714286v-.56880554C10.0087719.52308243 9.49266564 0 8.84162274 0H5.12255855c-.6445987 0-1.16714919.52078358-1.16714919 1.16918387v.59843518H1.16535983C.52174937 1.76761905 0 2.29315476 0 2.93921445v.48935698h14v-.51667502c0-.64879847-.5217834-1.17475355-1.1759129-1.17475355h-2.8153152z"
                            />
                          </g>
                        </svg>
                      </span>
                      <span class="link-text">Apagar</span>
                    </button>
                  </li>
                </ul>
              </div>
            </dropdown>
          </div>
          <!-- end device configurations -->
        </div>
        <div
          v-if="kioskDevices.length > 0"
          class="label-primary"
        >
          {{ $t('kiosks') }}
        </div>
        <div
          v-for="device in kioskDevices"
          :key="device.id"
          class="row space-between"
        >
          <div
            class="device tablet-device"
          >
            <div
              v-if="device.serviceID"
              class="device-name"
            >
              {{ device.serviceID }}
            </div>
            <div v-else>
              {{ $t('unbinded') }}
            </div>
            <div><span>{{ device.ip }}</span></div>
          </div>

          <!-- Device configurations -->
          <div class="device-configs">
            <dropdown :size="'sm'">
              <button
                slot="dropdown-trigger"
                type="button"
                class="btn-more-actions btn-tooltip"
                aria-haspopup="true"
                aria-expanded="false"
                :data-tooltip="$t('more.actions')"
                :aria-label="$t('more.actions')"
                :title="$t('more.actions')"
                onclick="document.querySelector('.dropdown').classList.toggle('dropdown-open');"
              />

              <div slot="dropdown-panel">
                <ul class="dropdown-menu">
                  <li
                    class="dropdown-menu__item"
                  >
                    <button
                      class="dropdown-menu__link"
                      @click="editDevice(device)"
                    >
                      <span class="link-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                        >
                          <g
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path d="M0 0h24v24H0z" />
                            <g fill="#8F95A1">
                              <path d="M18.8287402 6.17161133c-1.5622558-1.5618457-4.09494137-1.5618457-5.65675778 0L10.9400293 8.40268555c.17668945-.01921875.35522461-.02748047.53466797-.02748047.56484375 0 1.11410156.08973633 1.63409179.26273437l1.2647461-1.26430664c.43438476-.43485351 1.01206054-.67379883 1.62635744-.67379883.6143554 0 1.1920312.23894532 1.626416.67379883.4344141.43394531.6732715 1.01071289.6732715 1.62591797 0 .61429688-.2388574 1.19197266-.6732715 1.62591797l-2.4745606 2.47458984c-.43435542.43488282-1.0120605.67376953-1.62635738.67376953-.61523437 0-1.19197265-.23888671-1.62679687-.67376953-.21149414-.21058593-.37625977-.45594726-.48978516-.72328125-.28198242.01555664-.545625.13274414-.74704101.33413086l-.65915039.6600293c.18035156.33413086.41197265.64907227.69395508.93202148 1.5618164 1.56190432 4.0949414 1.56190432 5.65719723 0l2.475-2.47549804c1.5613477-1.56175782 1.5613477-4.09400391-.0000293-5.65584961z" />
                              <path d="M13.5519043 16.6238281c-.56578125 0-1.12054688-.0915527-1.65240235-.2719043l-1.27344726 1.2735059c-.43394532.4348828-1.0115918.6737988-1.62588867.6737988-.61429688 0-1.19103516-.238916-1.62591797-.6737988-.43485352-.4339746-.67379883-1.0115918-.67379883-1.625918s.23894531-1.19203123.67379883-1.62682615L9.84880859 11.898125c.43485352-.43394531 1.0116211-.67289062 1.62591797-.67289062.61520508 0 1.19197266.23894531 1.62632813.67289062.21152343.21146484.37666992.45682617.49072265.72413086.28289063-.01464844.54700196-.13274414.74841797-.33413086l.65824219-.65915039c-.18035156-.33509766-.41244141-.65000977-.69486328-.93290039-1.56181641-1.5618457-4.09494141-1.5618457-5.65675781 0l-2.47456055 2.47549805c-1.56272461 1.56190429-1.56272461 4.09406253 0 5.65681643 1.56181641 1.5619043 4.0940625 1.5619043 5.65584961 0l2.22826172-2.228291c-.16614258.015498-.33413086.0238183-.50352539.0238183l-.0009375-.0000879z" />
                            </g>
                          </g>
                        </svg>
                      </span>
                      <span class="link-text">Atribuir</span>
                    </button>
                  </li>

                  <li class="dropdown-menu__item">
                    <button
                      class="dropdown-menu__link"
                      @click="deleteDevice(device)"
                    >
                      <span class="link-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="17"
                        >
                          <g
                            fill="#8F95A1"
                            fill-rule="evenodd"
                          >
                            <path d="M1.16666667 4.57142857H12.8333333v9.65779223c0 1.2935657-1.0353388 2.3422078-2.3328841 2.3422078H3.49955081c-1.28841633 0-2.33288414-1.0439292-2.33288414-2.3422078V4.57142857z" />
                            <path
                              fill-rule="nonzero"
                              d="M10.0087719 1.73714286v-.56880554C10.0087719.52308243 9.49266564 0 8.84162274 0H5.12255855c-.6445987 0-1.16714919.52078358-1.16714919 1.16918387v.59843518H1.16535983C.52174937 1.76761905 0 2.29315476 0 2.93921445v.48935698h14v-.51667502c0-.64879847-.5217834-1.17475355-1.1759129-1.17475355h-2.8153152z"
                            />
                          </g>
                        </svg>
                      </span>
                      <span class="link-text">Apagar</span>
                    </button>
                  </li>
                </ul>
              </div>
            </dropdown>
          </div>
        </div>

        <div
          v-if="displayDevices.length === 0 && kioskDevices.length === 0"
          class="empty-state-container"
        >
          <div class="empty-state">
            <div class="empty-state__content">
              <div class="empty-state__illustration">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="276"
                  height="198"
                >
                  <g
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      fill="#EBEFF2"
                      transform="translate(26.4)"
                    >
                      <ellipse
                        cx="98.8"
                        cy="99"
                        opacity=".30000001"
                        rx="98.8"
                        ry="99"
                      />
                      <ellipse
                        cx="98.4"
                        cy="98.5991903"
                        opacity=".5"
                        rx="79.2"
                        ry="79.3603239"
                      />
                      <ellipse
                        cx="98"
                        cy="98.1983806"
                        rx="61.2"
                        ry="61.3238866"
                      />
                    </g>
                    <g transform="translate(87 20)">
                      <rect
                        width="38.028572"
                        height="53.1500295"
                        x="1.985714"
                        y="1.985714"
                        fill="#FFF"
                        stroke="#9C9FA7"
                        stroke-width="3.971428"
                        rx="2.2285713"
                      />
                      <path
                        fill="#9C9FA7"
                        d="M.2 47.8059472h41.6v5.97068267H.2z"
                      />
                      <rect
                        width="7.92380952"
                        height="1.99022756"
                        x="17.0380952"
                        y="51.7864023"
                        fill="#FFF"
                        rx=".99047613"
                      />
                      <g fill="#9C9FA7">
                        <path d="M21.48316344 25.99986801v-2.99584862c0-.31672057-.2495047-.57347332-.57446244-.57347332h-.02757189c-.31726685 0-.57446244.25669683-.57446244.57347332v3.60066102c0 .31873086.2495047.57711328.57446244.57711328h2.38511276c.31452151 0 .56949153-.25065604.56949153-.57711328v-.02769913c0-.31873086-.25176616-.57711327-.56949153-.57711327h-1.78307843z" />
                        <path d="M20.9683253 20.33438579c3.0444549 0 5.521101 2.48852587 5.521101 5.54723549 0 3.05899332-2.4766461 5.54723552-5.521101 5.54723552-3.04445494 0-5.52138338-2.4882422-5.52138338-5.54723552 0-3.05870962 2.47692844-5.54723549 5.52138338-5.54723549zm0-1.38673795c-3.81174511 0-6.90165863 3.10438106-6.90165863 6.93397344 0 3.82973422 3.08991352 6.93397342 6.90165863 6.93397342 3.8117451 0 6.9017998-3.1042392 6.9017998-6.93397342 0-3.82959238-3.0900547-6.93397344-6.9017998-6.93397344z" />
                      </g>
                    </g>
                    <g transform="translate(0 95.392713)">
                      <rect
                        width="101.028572"
                        height="57.1500291"
                        x="1.4857142"
                        y="1.4857142"
                        fill="#FFF"
                        stroke="#9C9FA7"
                        stroke-width="2.97142839"
                        rx="2.2285713"
                      />
                      <g fill="#9C9FA7">
                        <path d="M52.62120985 29.8001151v-3.83067063c0-.4049778-.33570355-.73327717-.73859456-.73327717h-.03544958c-.40791452 0-.73859457.32822787-.73859457.73327717v4.60401983c0 .4075483.33570356.7379314.73859457.7379314h3.05109009c.4129361 0 .7476869-.3354021.7476869-.7379314v-.03541776c0-.40754828-.3236994-.73793144-.7476869-.73793144h-2.27704595z" />
                        <path d="M51.9592751 22.55589181c3.9142992 0 7.0985585 3.18197752 7.0985585 7.09302598 0 3.91141121-3.1842593 7.09302601-7.0985585 7.09302601-3.91429921 0-7.09892149-3.1816148-7.09892149-7.09302601 0-3.91104846 3.18462228-7.09302598 7.09892149-7.09302598zm0-1.77316581c-4.90081514 0-8.8735611 3.96944668-8.8735611 8.86619179 0 4.89692651 3.97274596 8.86619181 8.8735611 8.86619181 4.9008151 0 8.8737426-3.9692653 8.8737426-8.86619181 0-4.89674511-3.9729275-8.86619179-8.8737426-8.86619179z" />
                      </g>
                      <path
                        fill="#9C9FA7"
                        d="M0 53.4412955h104v3.71120108H0z"
                      />
                      <ellipse
                        cx="94.64"
                        cy="56.7071525"
                        fill="#FFF"
                        rx="1.03999998"
                        ry="1.03913628"
                      />
                      <ellipse
                        cx="91.8914286"
                        cy="56.9298246"
                        fill="#FFF"
                        rx="1"
                        ry="1"
                      />
                    </g>
                    <g transform="translate(148 62.526316)">
                      <rect
                        width="124.342857"
                        height="70.8934646"
                        x="1.82857132"
                        y="1.82857132"
                        fill="#FFF"
                        stroke="#9C9FA7"
                        stroke-width="3.65714264"
                        rx="2.74285698"
                      />
                      <g fill="#9C9FA7">
                        <path d="M64.7645659 36.9521425v-4.7500316c0-.50217247-.4131736-.90926369-.9090395-.90926369h-.0436302c-.5020487 0-.90903949.40700256-.90903949.90926369v5.7089846c0 .5053599.41317359.915035.90903949.915035h3.7551877c.5082291 0 .9202301-.4158987.9202301-.915035v-.043918c0-.5053599-.412623-.915035-.9202301-.915035h-2.802518z" />
                        <path d="M63.949877 27.96930561c4.817599 0 8.7366873 3.94565212 8.7366873 8.79535219 0 4.8501499-3.9190883 8.7953522-8.7366873 8.7953522-4.81759905 0-8.73713417-3.9452023-8.73713417-8.7953522 0-4.84970007 3.91953512-8.79535219 8.73713417-8.79535219zm0-2.19872561c-6.03177251 0-10.921306 4.92211388-10.921306 10.9940778 0 6.0721889 4.88953349 10.9940778 10.921306 10.9940778 6.0317724 0 10.9215293-4.9218889 10.9215293-10.9940778 0-6.07196392-4.8897569-10.9940778-10.9215293-10.9940778z" />
                      </g>
                      <path
                        fill="#9C9FA7"
                        d="M0 66.2672065h128v4.8097166H0z"
                      />
                      <ellipse
                        cx="116.48"
                        cy="70.3168691"
                        fill="#FFF"
                        rx="1.27999998"
                        ry="1.28852899"
                      />
                      <ellipse
                        cx="113.097143"
                        cy="70.5929824"
                        fill="#FFF"
                        rx="1"
                        ry="1"
                      />
                    </g>
                    <g transform="translate(117.6 132.267206)">
                      <rect
                        width="16"
                        height="50.5020243"
                        fill="#9C9FA7"
                        rx="2.85938358"
                      />
                      <ellipse
                        cx="12.48"
                        cy="3.43843568"
                        fill="#FFF"
                        rx="1"
                        ry="1"
                      />
                      <ellipse
                        cx="10.5066667"
                        cy="3.59961236"
                        fill="#FFF"
                        rx="1"
                        ry="1"
                      />
                      <ellipse
                        cx="4.8"
                        cy="23.1019898"
                        fill="#FFF"
                        rx="2.13333333"
                        ry="2.14902231"
                      />
                      <ellipse
                        cx="11.2"
                        cy="23.1019898"
                        fill="#FFF"
                        rx="2.13333333"
                        ry="2.14902231"
                      />
                      <ellipse
                        cx="4.8"
                        cy="34.9216125"
                        fill="#FFF"
                        rx="2.13333333"
                        ry="2.14902231"
                      />
                      <ellipse
                        cx="4.8"
                        cy="41.3686795"
                        fill="#FFF"
                        rx="2.13333333"
                        ry="2.14902231"
                      />
                      <path
                        fill="#FFF"
                        d="M2.66666667 29.0118012h10.6666667v1H2.66666667z"
                      />
                      <rect
                        width="4.26666667"
                        height="11.2823671"
                        x="9.06666667"
                        y="32.2353347"
                        fill="#FFF"
                        rx="2.13333333"
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="empty-state__title">
                <h3 class="sr-only">
                  {{ $t('no.devices.description') }}
                </h3>
              </div>
              <div class="empty-state__description">
                <p>{{ $t('no.devices.description') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal v-model="editDeviceModal">
      <edit-device
        slot="modal-panel"
        v-model="editDeviceModal"
        :device="workingDevice"
      />
    </modal>
    <modal v-model="deleteDeviceModal">
      <delete-device
        slot="modal-panel"
        v-model="deleteDeviceModal"
        :device="workingDevice"
      />
    </modal>
  </main>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Modal from '@/components/utils/Modal'
import EditDevice from '@/components/modals/EditDevice'
import DeleteDevice from '@/components/modals/DeleteDevice'
import Dropdown from '@/components/utils/Dropdown'

export default {
  components: {
    Dropdown,
    Modal,
    EditDevice,
    DeleteDevice
  },
  props: {
    status: {
      type: String,
      required: true
    },
    serviceID: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      editDeviceModal: false,
      deleteDeviceModal: false,
      workingDevice: undefined
    }
  },
  computed: {
    ...mapState(['devices']),
    displayDevices (type) {
      return this.devices.filter(device => device.type === 'display')
    },
    kioskDevices (type) {
      return this.devices.filter(device => device.type === 'kiosk')
    }
  },
  async mounted () {
    if (this.serviceID) {
      await this.fetchServiceDevices({
        status: this.status,
        serviceID: this.serviceID
      })
    } else {
      await this.fetchDevices({ status: this.status })
    }
  },
  methods: {
    ...mapActions(['fetchDevices', 'fetchServiceDevices']),
    editDevice (device) {
      this.workingDevice = device
      this.editDeviceModal = true
    },
    deleteDevice (device) {
      this.workingDevice = device
      this.deleteDeviceModal = true
    },
    turnOnDevice (device) {},
    turnOffDevice (device) {}
  }
}
</script>
<style lang="scss">
.device-state-configs {
  margin-right: 5rem;
}

.button-dropdown {
  position: relative;
}

.btn-edit,
.btn-delete,
.btn-more-actions {
  position: relative;
  width: 3rem;
  height: 3rem;
  opacity: 0.5;
  transition: opacity 0.3s ease;
}
</style>
